export default __webpack_public_path__ + "static/fa-brands-400-55967548be36c02f29e9381bb50a3ff2.ttf";